<template>
  <!-- TODO: Show MTD logo if appropriate/enabled -->
  <!-- <img 
    v-if="$page.props.auth.user.mtd.logo_url && isTu()"
    class="site-logo"
    :alt="$page.props.auth.user.mtd.company_name"
    :src="$page.props.auth.user.mtd.logo_url"> -->
  <img src="/images/logo.png" class="fill-white site-logo"/>
</template>
